import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import es from './locales/es.json';
import en from './locales/en.json';

export const SUPPORTED_LANGS = ['it', 'es', 'en'];
export const LANG_LABELS = {
  it: { native: 'Italiano', flag: '🇮🇹' },
  es: { native: 'Español', flag: '🇪🇸' },
  en: { native: 'English', flag: '🇬🇧' },
};

// Read user lang from localStorage (synced with backend) or default to it
function initialLang() {
  try {
    const stored = JSON.parse(localStorage.getItem('ev_user') || 'null');
    if (stored?.language && SUPPORTED_LANGS.includes(stored.language)) {
      return stored.language;
    }
  } catch (err) {
    // Storage parse failed (corrupted JSON or storage disabled in private mode).
    // Log so we can spot the cause without crashing the whole app.
    // eslint-disable-next-line no-console
    console.warn('[i18n] could not read user language from storage:', err);
  }
  return 'it';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { it: { translation: it }, es: { translation: es }, en: { translation: en } },
    lng: initialLang(),
    fallbackLng: 'it',
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'], lookupLocalStorage: 'ev_lang' },
  });

export default i18n;
